export default __webpack_public_path__ + "static/media/logo-with-name.d50dd051.svg";